import React from 'react';

import {
  Modal,
} from 'web-components';

import Body from './Body';

type Props = {
  modalState: {
    isOpen: boolean;
    title?: string;
    helper?: string;
    buttonText?: string;
    folderName: string;
  }
  onSubmit: { (data: any, actions: any): void };
  onRequestClose: { (): void };
};

const MoveToFolder = ({
  modalState,
  onSubmit,
  onRequestClose,
}: Props) => (
  <Modal
    title={modalState.title || 'Move to Folder'}
    isOpen={modalState.isOpen}
    onRequestClose={onRequestClose}
  >
    <Body
      helper={modalState.helper || 'Select folder to move selected'}
      buttonText={modalState.buttonText || 'Move'}
      folderName={modalState.folderName}
      onSubmit={onSubmit}
    />
  </Modal>
);

export default MoveToFolder;
